import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApprovalDetailsComponent } from './approval-details.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NbButtonModule, NbCardModule, NbIconModule } from '@nebular/theme';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const component = ApprovalDetailsComponent

@NgModule({
  declarations: [component],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NbIconModule,
    NbCardModule,
    NbButtonModule
  ],
  exports: [component]
})
export class ApprovalDetailsModule { }
